import { render, staticRenderFns } from "./EventBannerGroupForm.vue?vue&type=template&id=0c8498d0&scoped=true&"
import script from "./EventBannerGroupForm.vue?vue&type=script&lang=js&"
export * from "./EventBannerGroupForm.vue?vue&type=script&lang=js&"
import style0 from "./EventBannerGroupForm.vue?vue&type=style&index=0&id=0c8498d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8498d0",
  null
  
)

export default component.exports